import { observer } from "mobx-react"
import Checkbox from "antd/es/checkbox/Checkbox"
import { Button, Input, InputNumber, Modal, Select, Space } from "antd";
import {DeleteOutlined, MinusOutlined, PlusOutlined} from "@ant-design/icons"
import { cartState } from "./CartState";
import EmptyCart from "../../share/misc/EmptyCart";
import formatCurrency from "../../utilities/helpers/FormatCurrency";
import { useEffect } from "react";
import './cart.css'
import { Link, useNavigate } from "react-router-dom";
import { exportOptionAntd } from "../../utilities/helpers/ExportOptionAntd";

const Cart = ()=>{
    const navigate = useNavigate()
    useEffect(()=>{
        cartState.getDishCartList();
    },[])
    return(
        <div className="cart container mx-auto">
            <div className="cart-title text-center text-2xl mt-5 mb-5 font-bold">Giỏ hàng của bạn</div>
            <div className="cart-content">
                <div className="table w-full border border-red-500 rounded-md p-2">
                    <table className="table-auto w-full border-separate border-spacing-y-2">
                        <thead>{/*6 cols*/}
                            <tr>
                                <th className="bg-red-500 p-2 text-white">
                                    <Checkbox/>
                                </th>
                                <th className="bg-red-500 p-2 text-white text-start">
                                    Sản phẩm
                                </th>
                                <th className="bg-red-500 p-2 text-white">
                                    Đơn giá
                                </th>
                                <th className="bg-red-500 p-2 text-white">
                                    Số lượng
                                </th>
                                <th className="bg-red-500 p-2 text-white">
                                    Thành tiền
                                </th>
                                <th className="bg-red-500 p-2 text-white">
                                    Ghi chú
                                </th>
                                <th className="bg-red-500 p-2 text-white">
                                    Thao tác
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {cartState.dishCartList.length === 0 ? (<tr><td colSpan={7} style={{border: 'none'}}><EmptyCart/></td></tr>):
                            (<>
                                {cartState.dishCartList.map((dish:any)=>(
                                    <tr className="bg-red-50 border-b border-red-500">
                                        <td className="text-center">
                                            <Checkbox></Checkbox>
                                        </td>
                                        <td>
                                            <div onClick={()=>{cartState.directToDish(dish.id, navigate)}} className="cursor-pointer">
                                                <img className="w-20 h-20 object-cover object-center inline-block rounded-md border border-red-500" src={dish.img} alt="" />
                                                <span className="whitespace-normal pl-4 align-middle">{dish.name}</span>
                                            </div>
                                        </td>
                                        <td className="text-center">{formatCurrency(dish.price)}</td>
                                        <td className="text-center">
                                            <Space.Compact>
                                                <Button size="small" type="default" danger onClick={()=>{cartState.handleChangeAmount('minus', dish)}}><MinusOutlined/></Button>
                                                <InputNumber controls={false} size="small" className="border-red-500" value={dish.quantity}/>
                                                <Button size="small" type="default" danger onClick={()=>{cartState.handleChangeAmount('plus', dish)}}><PlusOutlined/></Button>
                                            </Space.Compact>
                                        </td>
                                        <td className="text-center">
                                            {formatCurrency(Number(dish.price) *Number(dish.quantity))}
                                        </td>
                                        <td className="text-center">
                                            {dish.note ? dish.note : ''}
                                        </td>
                                        <td className="text-center">
                                            <Button type="default" danger onClick={()=>{cartState.handleOpenModal(dish)}}><DeleteOutlined/></Button>
                                        </td>
                                    </tr>
                                ))}
                            </>)}
                        </tbody>
                    </table>
                </div>
            </div>
            <Modal title="Xác nhận xoá"
                open={cartState.openModalStatus}
                onCancel={()=>{cartState.handleCloseModal()}}
                footer={[<Button type="default" danger onClick={()=>{cartState.handleCloseModal()}}>Huỷ</Button>, <Button type="primary" danger onClick={()=>{cartState.handleDeleteDishInCart(cartState.dishSpecificInfo ? cartState.dishSpecificInfo.id : '')}}>Xoá</Button>]}>
                    <p>Bạn có chắc chắn muốn xoá món ăn <span className="font-bold">{cartState.dishSpecificInfo ? cartState.dishSpecificInfo.name : ''}</span> khỏi giỏ hàng?</p>
            </Modal>
        </div>
    )
}
export default observer(Cart)